// import OneDimensionStrategy from './OneDimensionStrategy'

export default class BreadCrumbItem {
  constructor ({ dimension, filter, text }) {
    // if (oneDimensionStrategy.constructor !== OneDimensionStrategy) {
    //   throw new Error('oneDimensionParameters parametro no es una instancia de OneDimensionStrategy class')
    // }
    this.dimension = dimension
    this.text = text
    // this.oneDimensionStrategy = oneDimensionStrategy
    this.filter = filter
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/BreadCrumbItem.js